// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page___1IrVX","title":"title___3JOky"};